module.exports = __webpack_public_path__ + "img/5-4.c97bb03a.svg";